var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.92 8.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#555;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vSSsMN"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.33,8.69V6.2c0-.08,0-.11-.1-.11H4.59v2.5c0,.08,0,.11-.1.11H2.06a.45.45,0,0,1-.5-.49V5.07a.17.17,0,0,1,.08-.16L4,3,5.39,1.81c.06,0,.09,0,.14,0L9.12,4.77a.6.6,0,0,1,.25.52c0,1,0,1.94,0,2.9a.45.45,0,0,1-.5.5H6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,1.56v-1c0-.11,0-.22,0-.32A.22.22,0,0,1,7.86,0H9.12c.17,0,.24.1.24.27V2.92a.18.18,0,0,0,.06.14l1.32,1.09.09.08a.21.21,0,0,1,0,.31c-.13.17-.27.34-.41.5a.22.22,0,0,1-.33,0L8.83,4,6.31,1.87l-.85-.71-.4.33L.82,5c-.15.13-.26.12-.39,0L.1,4.6C0,4.43,0,4.33.14,4.19L1.82,2.78,4.71.38A2.19,2.19,0,0,1,5.1.09.81.81,0,0,1,6,.2L7.53,1.48A.44.44,0,0,0,7.63,1.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.02025c1b8abb86280d26e92ba164a659.svg";
export { ForwardRef as ReactComponent };